/**
 * yyyyMMdd 形式の文字列を Date に変換する
 *
 * @param dateStr システム日付（yyyyMMdd）
 * @returns 変換できた場合は Date、不正な場合は undefined
 */
export function parseYyyyMMddToDate(dateStr: string | undefined | null): Date | undefined {
  if (!dateStr || dateStr.length !== 8) {
    return undefined;
  }

  const year = Number(dateStr.substring(0, 4));
  const month = Number(dateStr.substring(4, 6));
  const day = Number(dateStr.substring(6, 8));
  if ([year, month, day].some((value) => Number.isNaN(value))) {
    return undefined;
  }

  return new Date(year, month - 1, day);
}
